import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Reports", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" There should be some description of the process of preparing the report ...")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" When report will available, then some download will visible. ")
const _hoisted_7 = { class: "mt-6 mb-6 pb-6" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "table is-fullwidth" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      width: "60%",
      class: "has-text-left"
    }, "Project name"),
    /*#__PURE__*/_createElementVNode("th", { class: "has-text-left" }, "Requested"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_11 = { class: "has-text-weight-bold" }
const _hoisted_12 = { class: "tag" }
const _hoisted_13 = { class: "has-text-right" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-credit-card" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Pay for the report", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, " Payed ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, " Processing... ", -1)
const _hoisted_24 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-word" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Download report", -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"control\"><p class=\"buttons\"><a href=\"/aureis_ai_platform.html\" class=\"button is-info icon-text is-outlined\"><span>+ Request a new report </span><span class=\"icon is-small\"><i class=\"fa fa-shopping-basket\"></i></span></a></p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (row, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(row.prjName), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(new Date(row.created).toLocaleDateString()), 1)
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    (row.status == 'new')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createElementVNode("button", {
                            class: "button is-info is-small",
                            onClick: _withModifiers(($event: any) => (_ctx.paymentPrepare(row.id)), ["prevent"])
                          }, _hoisted_18, 8, _hoisted_15)
                        ]))
                      : _createCommentVNode("", true),
                    (row.status == 'payed')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_24))
                      : _createCommentVNode("", true),
                    (row.status == 'approved')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "button is-danger is-small",
                            onClick: _withModifiers(($event: any) => (_ctx.download(row.id)), ["prevent"])
                          }, _hoisted_29, 8, _hoisted_26)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _hoisted_30
        ])
      ])
    ])
  ]))
}